'use client';

import { useStore } from '@/store/store';
import type { LogoutPopClientProps } from './logout-popup.client';
import { LogoutPopClient } from './logout-popup.client';

import './styles/@theme';
import type { LogOutPopData } from '@/types/aggregation/common';
import type { PrismicObject } from '@/types/prismic/common';

type LogoutPopupProps = {
    logoutPopup: PrismicObject<'logout_popup', LogOutPopData> | undefined;
};

// TODO: move read page config from logic instead of lib
export const LogoutPop = ({ logoutPopup }: LogoutPopupProps) => {
    const logoutPopupData = useStore((state) => state.popup.logoutPopupData);

    if (!logoutPopup && !logoutPopupData) {
        return null;
    }

    const { data } = (logoutPopup ?? logoutPopupData) as PrismicObject<'logout_popup', LogOutPopData>;

    const logoutPopupProps: LogoutPopClientProps = {
        logoUrl: data.logo.url,
        logoAlt: data.logo_alt[0]?.text || '',
        header: data.header[0]?.text || '',
        body: data.body[0]?.text || '',
        linkText: data.link_text?.[0]?.text || '',
        link: data.link.url!,
        bodySecond: data.body_second?.[0]?.text || '',
        buttonTitle: data.button_title[0]?.text || '',
        footer: data.footer?.[0]?.text || ''
    };

    return <LogoutPopClient {...logoutPopupProps} />;
};
